import React from 'react'

export default function SimpleDataTable({ title, columns, rows }) {
  return (
    <div className="w-full rounded-2xl border border-border-lines p-4">
      {title && <p className="text-base font-semibold text-dark-blue mb-3">{title}</p>}

      <div className="w-full overflow-x-auto">
        <table className="w-full min-w-[560px] text-sm">
          <thead>
            <tr className="bg-background">
              {columns.map((column) => (
                <th key={column.key} className="text-left font-semibold text-dark-blue px-3 py-2.5 whitespace-nowrap">
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {
              rows.map((row, index) => (
                <tr key={row.id ?? index} className="border-b border-border-lines last:border-0">
                  {columns.map((column) => (
                    <td key={column.key} className="px-3 py-3 text-dark-blue whitespace-nowrap">{row[column.key]}</td>
                  ))}
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    </div>
  )
}
